<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <b>{{code.name }}</b> Child List
      </p>
    </header>
    <section class="modal-card-body">
      <b-table :data="childs" :loading="loading" :columns="$options.columns">
        <template slot="empty">
          <div class="content has-text-grey has-text-centered">
            <p>NO RECORDS FOUND</p>
          </div>
        </template>
      </b-table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">Close</button>
    </footer>
  </div>
</template>
<script>
import { CodeService } from "@/services/code.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  codeService: CodeService,
  columns: [
    {
      field: "code",
      label: "Code"
    },
    {
      field: "name",
      label: "Name"
    },
    {
      field: "group",
      label: "Group"
    },
    {
      field: "type",
      label: "Type"
    }
  ],
  data: () => ({
    childs: [],
    loading: false
  }),
  props: {
    code: {
      type: Object,
      default: null
    }
  },
  created() {
    this.fetchCodes();
  },
  methods: {
    async fetchCodes() {
      this.loading = true;
      const code = await this.$options.codeService
        .show(this.code.id, { includes: "childCodes" })
        .then(response => JsonDenormalizer.denormalize(response));
      this.childs = code.childCodes;
      this.loading = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/codeConfigurator/partials/viewChildModal.vue